import pipe1 from "../../assets/image/product/pro-01.jpg";
import pipe2 from "../../assets/image/product/pro-02.jpg";
import pipe3 from "../../assets/image/product/pro-03.jpg";
import pipe4 from "../../assets/image/product/pro-04.jpg";
import pipe5 from "../../assets/image/product/pro-05.jpg";
import pipe6 from "../../assets/image/product/pro-06.jpg";
import pipe7 from "../../assets/image/product/pro-07.jpg";
import pipe8 from "../../assets/image/product/pro-08.jpg";
import pipe9 from "../../assets/image/product/pro-09.jpg";
import pipe10 from "../../assets/image/product/pro-10.jpg";
import pipe11 from "../../assets/image/product/pro-11.jpg";
import pipe12 from "../../assets/image/product/pro-12.jpg";
import pipe13 from "../../assets/image/product/pro-13.jpg";
import pipe14 from "../../assets/image/product/pro-14.jpg";
import pipe15 from "../../assets/image/product/pro-15.jpg";

export const productData = [
  {
    id: 1,
    name: "NP2 RCC Pipe",
    image: pipe1,
    price: "₹1,250 / Meter",
    size: "300mm - 1200mm",
    rating: 5,
  },
  {
    id: 2,
    name: "NP3 RCC Pipe",
    image: pipe2,
    price: "₹1,650 / Meter",
    size: "300mm - 1500mm",
    rating: 5,
  },
  {
    id: 3,
    name: "NP4 RCC Pipe",
    image: pipe3,
    price: "₹2,150 / Meter",
    size: "450mm - 1800mm",
    rating: 5,
  },
  {
    id: 4,
    name: "Hume Pipe",
    image: pipe4,
    price: "₹1,450 / Meter",
    size: "300mm - 1200mm",
    rating: 5,
  },
  {
    id: 5,
    name: "Spun RCC Pipe",
    image: pipe5,
    price: "₹1,850 / Meter",
    size: "600mm - 1800mm",
    rating: 5,
  },
  {
    id: 6,
    name: "Concrete Collar",
    image: pipe6,
    price: "₹650",
    size: "All Sizes",
    rating: 5,
  },
  {
    id: 7,
    name: "Manhole Ring",
    image: pipe7,
    price: "₹1,850",
    size: "Standard",
    rating: 5,
  },
  {
    id: 8,
    name: "Catch Pit Chamber",
    image: pipe8,
    price: "₹2,450",
    size: "Custom",
    rating: 5,
  },
  {
    id: 9,
    name: "Concrete Cover",
    image: pipe9,
    price: "₹350",
    size: "Heavy Duty",
    rating: 5,
  },
  {
    id: 10,
    name: "Drainage Pipe",
    image: pipe10,
    price: "₹1,400 / Meter",
    size: "300-1200mm",
    rating: 5,
  },
  {
    id: 11,
    name: "Irrigation Pipe",
    image: pipe11,
    price: "₹1,550 / Meter",
    size: "450-1500mm",
    rating: 5,
  },
  {
    id: 12,
    name: "Sewer Pipe",
    image: pipe12,
    price: "₹1,800 / Meter",
    size: "600-1800mm",
    rating: 5,
  },
  {
    id: 13,
    name: "Road Culvert Pipe",
    image: pipe13,
    price: "₹2,250 / Meter",
    size: "900-1800mm",
    rating: 5,
  },
  {
    id: 14,
    name: "Industrial RCC Pipe",
    image: pipe14,
    price: "₹2,550 / Meter",
    size: "1200-2000mm",
    rating: 5,
  },
  {
    id: 15,
    name: "Custom RCC Pipe",
    image: pipe15,
    price: "Contact Us",
    size: "As Required",
    rating: 5,
  },
];